/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DuplicateStudyPlanRequest,
    DuplicateStudyPlanRequestFromJSON,
    DuplicateStudyPlanRequestToJSON,
    DuplicateStudyPlansRequest,
    DuplicateStudyPlansRequestFromJSON,
    DuplicateStudyPlansRequestToJSON,
    StudyPlanDTO,
    StudyPlanDTOFromJSON,
    StudyPlanDTOToJSON,
    StudyPlanDTOPagedResponse,
    StudyPlanDTOPagedResponseFromJSON,
    StudyPlanDTOPagedResponseToJSON,
    StudyPlanStatusEnum,
    StudyPlanStatusEnumFromJSON,
    StudyPlanStatusEnumToJSON,
    UpdateStudyPlanInfoDTO,
    UpdateStudyPlanInfoDTOFromJSON,
    UpdateStudyPlanInfoDTOToJSON,
    UpdateStudyPlanStatusDTO,
    UpdateStudyPlanStatusDTOFromJSON,
    UpdateStudyPlanStatusDTOToJSON,
} from '../models';

export interface ApiStudyPlanBulkApproveSubjectsProgramIdStatusPostRequest {
    programId: string;
}

export interface ApiStudyPlanDuplicateStudyPlanPostRequest {
    duplicateStudyPlanRequest?: DuplicateStudyPlanRequest;
}

export interface ApiStudyPlanDuplicateStudyPlansPostRequest {
    duplicateStudyPlansRequest?: DuplicateStudyPlansRequest;
}

export interface ApiStudyPlanGenerateExtendedReportIdReportGetRequest {
    id: string;
}

export interface ApiStudyPlanGenerateReportIdReportGetRequest {
    id: string;
}

export interface ApiStudyPlanGenerateStudyPlanDiffReportIdReportGetRequest {
    id: string;
}

export interface ApiStudyPlanGenerateStudyPlanIndicatorsReportIdReportGetRequest {
    id: string;
}

export interface ApiStudyPlanGetAllStudyPlansStudyProgramIdGetRequest {
    studyProgramId: string;
    page?: number;
    pageSize?: number;
}

export interface ApiStudyPlanGetStudyPlanByIdStudyPlanIdGetRequest {
    studyPlanId: string;
}

export interface ApiStudyPlanGetStudyPlanByProgramIdAndYearStudyProgramIdPlanYearGetRequest {
    studyProgramId: string;
    planYear: number;
}

export interface ApiStudyPlanUpdateStudyPlanDepartmentStudyPlanIdDepartmentIdPutRequest {
    studyPlanId: string;
    departmentId: string;
}

export interface ApiStudyPlanUpdateStudyPlanInfoStudyPlanIdPutRequest {
    studyPlanId: string;
    updateStudyPlanInfoDTO?: UpdateStudyPlanInfoDTO;
}

export interface ApiStudyPlanUpdateStudyPlanStatusPostRequest {
    updateStudyPlanStatusDTO?: UpdateStudyPlanStatusDTO;
}

export interface ApiStudyPlanUpdateStudyPlanStatusStudyPlanIdStatusPutRequest {
    studyPlanId: string;
    state?: StudyPlanStatusEnum;
}

/**
 * 
 */
export class StudyPlanApi extends runtime.BaseAPI {

    /**
     */
    async apiStudyPlanBulkApproveSubjectsProgramIdStatusPostRaw(requestParameters: ApiStudyPlanBulkApproveSubjectsProgramIdStatusPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.programId === null || requestParameters.programId === undefined) {
            throw new runtime.RequiredError('programId','Required parameter requestParameters.programId was null or undefined when calling apiStudyPlanBulkApproveSubjectsProgramIdStatusPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/BulkApproveSubjects/{programId}/status`.replace(`{${"programId"}}`, encodeURIComponent(String(requestParameters.programId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStudyPlanBulkApproveSubjectsProgramIdStatusPost(requestParameters: ApiStudyPlanBulkApproveSubjectsProgramIdStatusPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiStudyPlanBulkApproveSubjectsProgramIdStatusPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiStudyPlanDuplicateStudyPlanPostRaw(requestParameters: ApiStudyPlanDuplicateStudyPlanPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/DuplicateStudyPlan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DuplicateStudyPlanRequestToJSON(requestParameters.duplicateStudyPlanRequest),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiStudyPlanDuplicateStudyPlanPost(requestParameters: ApiStudyPlanDuplicateStudyPlanPostRequest = {}, initOverrides?: RequestInit): Promise<string> {
        const response = await this.apiStudyPlanDuplicateStudyPlanPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyPlanDuplicateStudyPlansPostRaw(requestParameters: ApiStudyPlanDuplicateStudyPlansPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/DuplicateStudyPlans`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DuplicateStudyPlansRequestToJSON(requestParameters.duplicateStudyPlansRequest),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiStudyPlanDuplicateStudyPlansPost(requestParameters: ApiStudyPlanDuplicateStudyPlansPostRequest = {}, initOverrides?: RequestInit): Promise<number> {
        const response = await this.apiStudyPlanDuplicateStudyPlansPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyPlanGenerateExtendedReportIdReportGetRaw(requestParameters: ApiStudyPlanGenerateExtendedReportIdReportGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiStudyPlanGenerateExtendedReportIdReportGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/GenerateExtendedReport/{id}/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiStudyPlanGenerateExtendedReportIdReportGet(requestParameters: ApiStudyPlanGenerateExtendedReportIdReportGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiStudyPlanGenerateExtendedReportIdReportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyPlanGenerateReportIdReportGetRaw(requestParameters: ApiStudyPlanGenerateReportIdReportGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiStudyPlanGenerateReportIdReportGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/GenerateReport/{id}/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiStudyPlanGenerateReportIdReportGet(requestParameters: ApiStudyPlanGenerateReportIdReportGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiStudyPlanGenerateReportIdReportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyPlanGenerateStudyPlanDiffReportIdReportGetRaw(requestParameters: ApiStudyPlanGenerateStudyPlanDiffReportIdReportGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiStudyPlanGenerateStudyPlanDiffReportIdReportGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/GenerateStudyPlanDiffReport/{id}/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiStudyPlanGenerateStudyPlanDiffReportIdReportGet(requestParameters: ApiStudyPlanGenerateStudyPlanDiffReportIdReportGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiStudyPlanGenerateStudyPlanDiffReportIdReportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyPlanGenerateStudyPlanIndicatorsReportIdReportGetRaw(requestParameters: ApiStudyPlanGenerateStudyPlanIndicatorsReportIdReportGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiStudyPlanGenerateStudyPlanIndicatorsReportIdReportGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/GenerateStudyPlanIndicatorsReport/{id}/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiStudyPlanGenerateStudyPlanIndicatorsReportIdReportGet(requestParameters: ApiStudyPlanGenerateStudyPlanIndicatorsReportIdReportGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiStudyPlanGenerateStudyPlanIndicatorsReportIdReportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyPlanGetAllStudyPlansStudyProgramIdGetRaw(requestParameters: ApiStudyPlanGetAllStudyPlansStudyProgramIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StudyPlanDTOPagedResponse>> {
        if (requestParameters.studyProgramId === null || requestParameters.studyProgramId === undefined) {
            throw new runtime.RequiredError('studyProgramId','Required parameter requestParameters.studyProgramId was null or undefined when calling apiStudyPlanGetAllStudyPlansStudyProgramIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['Page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['PageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/GetAllStudyPlans/{studyProgramId}`.replace(`{${"studyProgramId"}}`, encodeURIComponent(String(requestParameters.studyProgramId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudyPlanDTOPagedResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiStudyPlanGetAllStudyPlansStudyProgramIdGet(requestParameters: ApiStudyPlanGetAllStudyPlansStudyProgramIdGetRequest, initOverrides?: RequestInit): Promise<StudyPlanDTOPagedResponse> {
        const response = await this.apiStudyPlanGetAllStudyPlansStudyProgramIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyPlanGetStudyPlanByIdStudyPlanIdGetRaw(requestParameters: ApiStudyPlanGetStudyPlanByIdStudyPlanIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StudyPlanDTO>> {
        if (requestParameters.studyPlanId === null || requestParameters.studyPlanId === undefined) {
            throw new runtime.RequiredError('studyPlanId','Required parameter requestParameters.studyPlanId was null or undefined when calling apiStudyPlanGetStudyPlanByIdStudyPlanIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/GetStudyPlanById/{studyPlanId}`.replace(`{${"studyPlanId"}}`, encodeURIComponent(String(requestParameters.studyPlanId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudyPlanDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiStudyPlanGetStudyPlanByIdStudyPlanIdGet(requestParameters: ApiStudyPlanGetStudyPlanByIdStudyPlanIdGetRequest, initOverrides?: RequestInit): Promise<StudyPlanDTO> {
        const response = await this.apiStudyPlanGetStudyPlanByIdStudyPlanIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyPlanGetStudyPlanByProgramIdAndYearStudyProgramIdPlanYearGetRaw(requestParameters: ApiStudyPlanGetStudyPlanByProgramIdAndYearStudyProgramIdPlanYearGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StudyPlanDTO>> {
        if (requestParameters.studyProgramId === null || requestParameters.studyProgramId === undefined) {
            throw new runtime.RequiredError('studyProgramId','Required parameter requestParameters.studyProgramId was null or undefined when calling apiStudyPlanGetStudyPlanByProgramIdAndYearStudyProgramIdPlanYearGet.');
        }

        if (requestParameters.planYear === null || requestParameters.planYear === undefined) {
            throw new runtime.RequiredError('planYear','Required parameter requestParameters.planYear was null or undefined when calling apiStudyPlanGetStudyPlanByProgramIdAndYearStudyProgramIdPlanYearGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/GetStudyPlanByProgramIdAndYear/{studyProgramId}/{planYear}`.replace(`{${"studyProgramId"}}`, encodeURIComponent(String(requestParameters.studyProgramId))).replace(`{${"planYear"}}`, encodeURIComponent(String(requestParameters.planYear))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudyPlanDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiStudyPlanGetStudyPlanByProgramIdAndYearStudyProgramIdPlanYearGet(requestParameters: ApiStudyPlanGetStudyPlanByProgramIdAndYearStudyProgramIdPlanYearGetRequest, initOverrides?: RequestInit): Promise<StudyPlanDTO> {
        const response = await this.apiStudyPlanGetStudyPlanByProgramIdAndYearStudyProgramIdPlanYearGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyPlanUpdateStudyPlanDepartmentStudyPlanIdDepartmentIdPutRaw(requestParameters: ApiStudyPlanUpdateStudyPlanDepartmentStudyPlanIdDepartmentIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.studyPlanId === null || requestParameters.studyPlanId === undefined) {
            throw new runtime.RequiredError('studyPlanId','Required parameter requestParameters.studyPlanId was null or undefined when calling apiStudyPlanUpdateStudyPlanDepartmentStudyPlanIdDepartmentIdPut.');
        }

        if (requestParameters.departmentId === null || requestParameters.departmentId === undefined) {
            throw new runtime.RequiredError('departmentId','Required parameter requestParameters.departmentId was null or undefined when calling apiStudyPlanUpdateStudyPlanDepartmentStudyPlanIdDepartmentIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/UpdateStudyPlanDepartment/{studyPlanId}/{departmentId}`.replace(`{${"studyPlanId"}}`, encodeURIComponent(String(requestParameters.studyPlanId))).replace(`{${"departmentId"}}`, encodeURIComponent(String(requestParameters.departmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStudyPlanUpdateStudyPlanDepartmentStudyPlanIdDepartmentIdPut(requestParameters: ApiStudyPlanUpdateStudyPlanDepartmentStudyPlanIdDepartmentIdPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiStudyPlanUpdateStudyPlanDepartmentStudyPlanIdDepartmentIdPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiStudyPlanUpdateStudyPlanInfoStudyPlanIdPutRaw(requestParameters: ApiStudyPlanUpdateStudyPlanInfoStudyPlanIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.studyPlanId === null || requestParameters.studyPlanId === undefined) {
            throw new runtime.RequiredError('studyPlanId','Required parameter requestParameters.studyPlanId was null or undefined when calling apiStudyPlanUpdateStudyPlanInfoStudyPlanIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/UpdateStudyPlanInfo/{studyPlanId}`.replace(`{${"studyPlanId"}}`, encodeURIComponent(String(requestParameters.studyPlanId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateStudyPlanInfoDTOToJSON(requestParameters.updateStudyPlanInfoDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStudyPlanUpdateStudyPlanInfoStudyPlanIdPut(requestParameters: ApiStudyPlanUpdateStudyPlanInfoStudyPlanIdPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiStudyPlanUpdateStudyPlanInfoStudyPlanIdPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiStudyPlanUpdateStudyPlanStatusPostRaw(requestParameters: ApiStudyPlanUpdateStudyPlanStatusPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/UpdateStudyPlanStatus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateStudyPlanStatusDTOToJSON(requestParameters.updateStudyPlanStatusDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStudyPlanUpdateStudyPlanStatusPost(requestParameters: ApiStudyPlanUpdateStudyPlanStatusPostRequest = {}, initOverrides?: RequestInit): Promise<void> {
        await this.apiStudyPlanUpdateStudyPlanStatusPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiStudyPlanUpdateStudyPlanStatusStudyPlanIdStatusPutRaw(requestParameters: ApiStudyPlanUpdateStudyPlanStatusStudyPlanIdStatusPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.studyPlanId === null || requestParameters.studyPlanId === undefined) {
            throw new runtime.RequiredError('studyPlanId','Required parameter requestParameters.studyPlanId was null or undefined when calling apiStudyPlanUpdateStudyPlanStatusStudyPlanIdStatusPut.');
        }

        const queryParameters: any = {};

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyPlan/UpdateStudyPlanStatus/{studyPlanId}/status`.replace(`{${"studyPlanId"}}`, encodeURIComponent(String(requestParameters.studyPlanId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStudyPlanUpdateStudyPlanStatusStudyPlanIdStatusPut(requestParameters: ApiStudyPlanUpdateStudyPlanStatusStudyPlanIdStatusPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiStudyPlanUpdateStudyPlanStatusStudyPlanIdStatusPutRaw(requestParameters, initOverrides);
    }

}
